import React, { useState, useEffect } from 'react';
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Layout from '../../components/Layout';
import api from '../../config/api';

import {
  Container,
  Input,
  InputContainer,
  InputLabel,
  Button,
  Form,
  ErrorText,
  Header,
  Description,
  WarnContainer,
  WarnBody,
  BoldText,
} from './styles';

const ForgottenPassword = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [resetComplete, setResetComplete] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    setErrorMessage('');
  }, [username, email]);

  useEffect(() => {
    if (token) {
      navigate("/chatbot", { replace: true });
    }
  }, [token, navigate]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setErrorMessage("Please enter a valid email address");
      return;
    }

    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/api/users/reset-password`,
        { username, email }
      );
      if (response.status === 200) {
        setResetComplete(true);
      }
    } catch (error) {
      console.error("Error updating password:", error);
      if (error.status === 404) {
        setErrorMessage('Username or email does not match our records');
      } else { 
        setErrorMessage("An error occurred. Please try again.");
      }
    }
  };

  return (
    <Layout>
      <Container>
        <Header>Sign in to SH+ Assistant</Header>
        {resetComplete ? (
          <>
            <Description>Your new temporary password has been sent to your email address. Please review your mailbox and use a new password in your next login.</Description>
            <Button onClick={() => navigate('/login')}>
              Go To Login
            </Button>
          </>
        ) : (
          <Form onSubmit={handleChangePassword}>
            <WarnContainer>
              <WarnBody><BoldText>Important:</BoldText> The password you have reset here is for your SH+ Assistant and <BoldText>does not change</BoldText> your SH+ password.</WarnBody>
              <WarnBody>You will continue to use <BoldText>separate passwords</BoldText> for SH+ Assistant and SH+.</WarnBody>
            </WarnContainer>
            <Description>Insert your SH+ Assistant Username and Email Address registered with your SH+ Assistant account to reset your password. You will receive your temporary password to your email address.</Description>
            <InputLabel>SH+ Assistant Username</InputLabel>
            <InputContainer>
              <Input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
              />
            </InputContainer>
            <InputLabel>Email Address</InputLabel>
            <InputContainer>
              <Input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Confirm your email address"
              />
            </InputContainer>
            {errorMessage && <ErrorText>{errorMessage}</ErrorText>}
            <Button
              disabled={!username || !email}
              type="submit"
            >
              Reset Password
            </Button>
          </Form>
        )}
      </Container>
    </Layout>
  );
};

export default ForgottenPassword;
